import React from 'react';
import { Sparkles, ArrowRight, Award, Briefcase } from 'lucide-react';

const AboutSection = () => {
  return (
    <section className="about-section-container" id="about">
      <div className="about-content-wrapper">
        
        {/* Top Header Row */}
        <div className="about-top-header">
          
          {/* Badge */}
          <div className="about-who-badge">
            <Sparkles size={14} className="badge-icon" />
            <span>About Me</span>
          </div>

          {/* Main Title */}
          <h2 className="about-main-title">
            INSURANCE GUIDANCE<br />BUILT AROUND YOUR FUTURE
          </h2>

          {/* Subtitle Description */}
          <p className="about-main-desc">
            With 23 years of professional experience and 4 years of entrepreneurial journey,
            Mrs. P. Meenakshi brings dedicated expertise in life insurance and risk management,
            helping individuals, families, and businesses plan for a more secure future.
          </p>

          {/* CTA Button */}
          <a href="#about-more" className="btn-more-about">
            <span>More About Us</span>
            <ArrowRight size={18} className="btn-arrow" />
          </a>

        </div>

        {/* Bottom 2-Column Content Grid */}
        <div className="about-bottom-grid">
          
          {/* Left Column: Mrs. P. Meenakshi Experience Image Card */}
          <div className="about-experience-card">
            <img
              src={process.env.PUBLIC_URL + '/images/Home/mrs-meenakshi.jpeg'}
              alt="Mrs. P. Meenakshi - 23 Years Professional Experience"
              className="about-card-img"
            />
            {/* Overlay badge on image */}
            <div className="exp-overlay-badge">
              <span className="exp-number">23 Years</span>
              <span className="exp-label">Professional Experience</span>
            </div>
          </div>

          {/* Right Column: Mission Statement & Key Metrics */}
          <div className="about-right-info">
            
            {/* Guide Statement */}
            <h3 className="about-statement">
              My strength lies in identifying and quantifying the risks involved in an emerging
              enterprise and suggesting appropriate risk-management strategies,{' '}
              <span className="statement-grey">
                with a focus on sustainability and business continuity across generations.
              </span>
            </h3>

            {/* Metrics Row */}
            <div className="about-stats-row">
              
              {/* Stat 1 */}
              <div className="stat-card">
                <div className="stat-icon-wrapper">
                  <Award size={28} className="stat-icon" />
                </div>
                <h4 className="stat-value">23 Years</h4>
                <p className="stat-caption">
                  Professional Experience
                </p>
              </div>

              {/* Stat 2 */}
              <div className="stat-card">
                <div className="stat-icon-wrapper">
                  <Briefcase size={28} className="stat-icon" />
                </div>
                <h4 className="stat-value">4 Years</h4>
                <p className="stat-caption">
                  Entrepreneurial Journey
                </p>
              </div>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default AboutSection;
